import React from 'react' // eslint-disable-line no-unused-vars
import { isMobileDevice } from '../../functions.js'
import { PATIENT } from '../../constants'

const HeroImageHome = ({languageContent, userType}) => {
    const userLanguageContent = userType === PATIENT ? languageContent.patient : languageContent

    return (
        <React.Fragment>
            { isMobileDevice()
                ? <HeroImageMobile title={userLanguageContent.headerMobile} subTitle={userLanguageContent.subHeader} userType={userType} />
                : <HeroImageDesktop title={userLanguageContent.header} subTitle={userLanguageContent.subHeader} userType={userType} />
            }
        </React.Fragment>
    )}

const HeroImageMobile = ({title, subTitle, userType}) => {

    const styles = {
        width: '100%',
        minHeight: '222px',
        padding: '25px',
        textAlign: 'center',
        color: 'white',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }

    const heroStyle = userType === PATIENT
        ? {
            backgroundImage: 'linear-gradient(rgba(17, 42, 65, 0.6), rgba(17, 42, 65, 0.6)), url(/assets/images/main_jumbotron_background_patient_mobile-750x380.jpg)',
            ...styles
          }
        : {
            backgroundImage: 'linear-gradient(rgba(33, 33, 33, 0.2), rgba(33, 33, 33, 0.2)), url(/assets/images/main_jumbotron_background_mobile.jpg)',
            ...styles
        }

        return (
            <div style={heroStyle}>
                <div style={{ fontSize: '20px', fontWeight: 'bold', maxWidth: '900px', lineHeight: '27px' }}>
                    {title}
                </div>
                <div style={{ fontSize: '15px', maxWidth: '900px', padding: '8px 0', lineHeight: '22px'  }}>
                    {subTitle}
                </div>
            </div>
        )}

const HeroImageDesktop = ({ title, subTitle, userType }) => {

    const styles = {
        width: '100%',
        minHeight: '311px',
        padding: '25px',
        textAlign: 'center',
        color: 'white',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    }

    const heroStyle = userType === PATIENT
        ? {
            backgroundImage: 'linear-gradient(rgba(17, 42, 65, 0.6), rgba(17, 42, 65, 0.6)), url(/assets/images/main_jumbotron_background-patient-1440x300.jpg)',
            ...styles,
          }
        : {
            backgroundImage: 'linear-gradient(rgba(33, 33, 33, 0.2), rgba(33, 33, 33, 0.2)), url(/assets/images/main_jumbotron_background-2.jpg)',
            backgroundPosition: 'center',
            ...styles
        }

    return (
        <div style={heroStyle}>
            <div style={{ fontSize: '38px', fontWeight: 'bold', maxWidth: '900px', lineHeight: '1.16' }}>
                {title}
            </div>
            <div style={{ fontSize: '20px', maxWidth: '900px', padding: '8px 0' }}>
                {subTitle}
            </div>
        </div>
    )}

export default HeroImageHome


// WEBPACK FOOTER //
// ./src/mi-app/home/HeroImageHome.js